import { forwardRef, InputHTMLAttributes, useState } from 'react';

import classNames from 'classnames';

import { Field, IFieldProps, useField } from '../Field/Field';

import styles from './file-upload.module.scss';

import { InputEvent } from 'types';

interface IFileUpload
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'defaultValue'>,
    IFieldProps {
  chooseFileText?: string;
  buttonText?: string;
  onChange: (e: InputEvent) => void;
}
const FileUpload = forwardRef<HTMLInputElement, IFileUpload>((props, ref) => {
  const {
    id,
    label,
    labelContent,
    helpText,
    errorMessage,
    wrapperClassName,
    className,
    chooseFileText = 'Choose file...',
    buttonText = 'Browse...',
    onChange,
    error,
    disabled,
    accept = '.jpeg, .jpg, .png',
    'aria-describedby': describedBy,
    'aria-invalid': ariaInvalid,
    ...restProps
  } = props;
  const { fieldId, descriptionIds } = useField(
    id,
    describedBy,
    helpText,
    errorMessage,
    error,
  );
  const [fileName, setFileName] = useState<string>();
  const getFileName = (event: InputEvent): void => {
    setFileName(event.currentTarget.files?.[0]?.name);
    onChange(event);
  };
  return (
    <Field
      {...{
        fieldId,
        label,
        labelContent,
        helpText,
        errorMessage,
        error,
        wrapperClassName,
      }}
    >
      <div
        className={classNames(styles['file-upload'], {
          [styles['file-upload--error']]: error,
          [styles.disabled]: disabled,
        })}
      >
        <input
          {...restProps}
          ref={ref}
          id={fieldId}
          className={classNames(styles.input, className)}
          type="file"
          disabled={disabled}
          aria-invalid={error || ariaInvalid}
          aria-describedby={descriptionIds}
          onChange={getFileName}
          accept={accept}
        />
        <span className={styles.filename} aria-hidden="true" title={fileName}>
          {fileName ?? chooseFileText}
        </span>
        <span className={styles.btn} aria-hidden="true">
          {buttonText}
        </span>
      </div>
    </Field>
  );
});
FileUpload.displayName = 'FileUpload';
export { FileUpload };
